import { z } from 'zod';
/** Версия публичного клиентского API. Меняется только при несовместимых правках. */
export const API_VERSION = 'v1';
export const API_PREFIX = `/api/${API_VERSION}`;
/** Тип единицы каталога. Сезоны/эпизоды добавятся отдельными типами позже. */
export const mediaKindSchema = z.enum(['movie', 'tv']);
/**
 * Источник metadata. Внутренний идентификатор, а не URL: клиент не должен
 * получать внешние origin (см. ARCHITECTURE.md §7.1).
 *
 * `local` — файлы медиатеки сервера: metadata берётся из имени файла и
 * `ffprobe`, а не из внешнего провайдера.
 */
export const metadataSourceSchema = z.enum(['tmdb', 'demo', 'local']);
/**
 * Стабильный типизированный идентификатор: `tmdb:movie:550`, `demo:tv:1`.
 * Числовой TMDB ID намеренно не используется как единственный ключ —
 * иначе фильмы, сериалы и эпизоды смешиваются (TMDB_INTEGRATION.md).
 */
export const CONTENT_ID_PATTERN = /^(tmdb|demo|local):(movie|tv):([A-Za-z0-9_-]{1,64})$/;
export const contentIdSchema = z.string().regex(CONTENT_ID_PATTERN, 'invalid content id');
export function buildContentId(source, kind, externalId) {
    return `${source}:${kind}:${externalId}`;
}
export function parseContentId(value) {
    const match = CONTENT_ID_PATTERN.exec(value);
    if (!match)
        return null;
    const [, source, kind, externalId] = match;
    if (!source || !kind || !externalId)
        return null;
    return {
        source: source,
        kind: kind,
        externalId,
    };
}
/**
 * Ссылка на изображение. `url` — ВСЕГДА относительный путь нашего API.
 * Внешний image origin в DTO клиента не попадает.
 */
export const imageRefSchema = z.object({
    url: z.string().startsWith('/api/'),
    width: z.number().int().positive().optional(),
    height: z.number().int().positive().optional(),
});
/** Допустимые размеры изображений. Клиент не может задать произвольный размер. */
// `w1280` — только для кадров (backdrop): чёткий фон слайдера главной на
// широком экране. Постеры у TMDB этой ширины не имеют.
export const IMAGE_SIZES = ['w92', 'w154', 'w185', 'w342', 'w500', 'w780', 'w1280', 'original'];
export const imageSizeSchema = z.enum(IMAGE_SIZES);
export const paginationSchema = z.object({
    page: z.number().int().positive(),
    totalPages: z.number().int().nonnegative(),
    totalResults: z.number().int().nonnegative(),
});
//# sourceMappingURL=common.js.map